import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Forums',
    data () {
        return {
            admin:{},
            forums: {},
            forum: {},
            viewFlag: "",
            setDeleteForum:false,
            setDeleteForumComment:false,
            img_url: service.imageURL,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "viewAll"){
                this.viewFlag = false;
            }
            if(attr == "view"){
                this.viewFlag = true;
                this.forum = attr2;
            }
            if(attr == "delete-forum"){
                this.setDeleteForum = true;
            }
            if(attr == "delete-forum-comment"){
                this.setDeleteForumComment = true;
            }
            
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and forums
        
        //get all saved listings
        getForums() {
            service.getAllForums(this).then(data => {
               if(data.body.status == 200) {
                    this.forums = data.body.data;
                   }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

      
        deleteForum(){
            service.deleteForum(this, this.forum.forum_id).then((response) => {
                if(response.body.status = 200) {
                    this.forum = []; this.viewFlag = false;
                    toastr.success("Forum Deleted", 'Successful'); 
                    this.setDeleteForum = false;
                }else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
                }
            })
        },

        deleteForumComment(forum_comment_id){
            service.deleteForumComment(this, forum_comment_id).then((response) => {
                if(response.body.status = 200) {
                    toastr.success("Discussion Deleted", 'Successful'); 
                    const index = this.forum.forum_comments.findIndex(fc => fc.forum_comment_id === forum_comment_id) //best removal
                    this.forum.forum_comments.splice(index, 1);
                }else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
                }
            })
        },
     
    },
    created: function(){
        this.preset();
        this.getForums();
    }
}


// WEBPACK FOOTER //
// ./src/components/Forums/script.js